import { colors } from 'constants/styles/colors';
import styled from 'styled-components';

export const StatCardContainer = styled.div`
  &&& {
    flex: initial;
    max-width: 100%;
    width: auto;
    padding: 10px 20px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
    cursor: pointer;

    &:hover {
      box-shadow: 10px 10px 10px rgba(0, 0, 0, 0.200691);
    }
    &:active {
      /* Ring via box-shadow instead of border: a border adds to the box's
         layout size, shifting the row while the mouse is held down. */
      box-shadow: 0 0 0 1px ${colors.palette.Business_DataVizLilacLighter};
    }
  }

  .ant-radio-wrapper {
    align-items: center;
    margin-right: 5px;
  }

  .ant-radio-wrapper::after {
    content: none;
  }

  .ant-radio {
    top: 0;
  }

  .ant-radio-inner,
  .ant-radio-checked .ant-radio-inner {
    width: 20px;
    height: 20px;
    border: 0;
    background-color: ${colors.palette.Business_LightThemeGreyLighter};
  }

  .ant-radio-inner::after {
    top: 50%;
    left: 50%;
    width: 10px;
    height: 10px;
    margin-top: -5px;
    margin-left: -5px;
    background-color: ${colors.palette.Business_DataVizLilacLighter};
  }

  .ant-radio-checked .ant-radio-inner::after {
    transform: scale(1);
  }

  .ant-radio-wrapper:hover .ant-radio-inner,
  .ant-radio:hover .ant-radio-inner {
    border-color: transparent;
  }
`;
